import { Link, useLocation } from 'react-router-dom';
import { cart, useCart } from '../lib/cart';
import { Money } from './Money';

/**
 * Sticky bottom bar — surfaces the current draft cart so the sales girl
 * never loses track of what she's added from the catalogue. Hidden on the
 * NewOrder page itself (the page reads the cart directly).
 */
export function CartBar(): JSX.Element | null {
  const location = useLocation();
  const { items, totalUnits } = useCart();

  if (items.length === 0) return null;
  if (location.pathname === '/orders/new') return null;
  if (location.pathname === '/quotations/new') return null;
  if (location.pathname.startsWith('/login')) return null;

  const subtotal = items.reduce((s, l) => s + l.qty * l.unitPrice, 0);

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-ink text-paper-2 rounded-lg shadow-2xl border border-ink-2 flex items-center gap-4 px-4 py-3 max-w-[min(680px,calc(100vw-32px))]">
      <div className="flex items-center gap-2 text-sm">
        <span className="w-7 h-7 rounded-full bg-accent text-white text-xs font-medium flex items-center justify-center kc-mono">
          {totalUnits}
        </span>
        <span className="text-paper-2/90 hidden sm:inline">
          {items.length} product{items.length === 1 ? '' : 's'} ·{' '}
          <Money value={subtotal} className="text-paper-2" />
        </span>
        <span className="text-paper-2/90 sm:hidden">
          <Money value={subtotal} className="text-paper-2" />
        </span>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <button
          type="button"
          onClick={() => cart.clear()}
          className="text-paper-2/70 hover:text-paper-2 hover:bg-paper-2/10 text-sm px-2.5 py-2 rounded transition focus:outline-none focus-visible:ring-2 focus-visible:ring-paper-2/40"
          title="Clear selected products"
        >
          Clear
        </button>
        <Link
          to="/quotations/new"
          className="inline-flex items-center gap-1 border border-paper-2/30 text-paper-2 hover:bg-paper-2/10 text-sm px-3 py-2 rounded font-medium transition"
        >
          Quote →
        </Link>
        <Link
          to="/orders/new"
          className="inline-flex items-center gap-1 bg-accent hover:bg-accent/90 text-white text-sm px-4 py-2 rounded font-medium transition"
        >
          Order →
        </Link>
      </div>
    </div>
  );
}
